import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import history from '../../common/history';
import UrlCollect from '../../common/url-collect';
import ShowNotification from '../../components/react-notifications/react-notifications';
import { NotificationMessageType } from '../../utils/configuration';


export const ModalSearch = (props) => {
    const { show, onHide, listLookupCommune } = props;
    const [communeSelect, setCommuneSelect] = useState([]);

    const onSubmit = () => {
        if (communeSelect.length > 0) {
            history.push(`${UrlCollect.PlanningMap}?commune=${communeSelect.join(',')}`);
            setCommuneSelect([]);
            onHide();
        }
        else {
            ShowNotification("Vui lòng chọn xã/phường", NotificationMessageType.Warning);
        }
    };

    const handleOnChangeCommune = (data) => {
        if (data) {
            setCommuneSelect(
                data.map((item) => item.value)
            )
        } else {
            setCommuneSelect([]);
        }
    };

    const colourStyles = {
        control: (styles) => ({ ...styles, 
            backgroundColor: 'white',
            padding: '5px 10px 5px 10px',
            fontSize: '16px',
            borderRadius: '50px 0 0 50px',
            border: '1px solid #ccc',
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,            
          };
        }
    };
    return (
        <Modal show={show} onHide={onHide} size="lg" className="modal-search">
            <Modal.Body>
                <div className="auth-container d-flex gap-4">
                    {listLookupCommune && listLookupCommune.length > 0 && (
                        <Select
                            className="basic-single flex-grow-1"
                            classNamePrefix="select"
                            placeholder="Xã/ Phường"
                            name="commune"
                            defaultValue={
                                listLookupCommune.filter((item) => {
                                    if (typeof (communeSelect) == "string") return null;
                                    if (communeSelect.some((id) => id == item.id)) return item;
                                })
                            }
                            closeMenuOnSelect={false}
                            isMulti
                            onChange={handleOnChangeCommune}
                            options={listLookupCommune}
                            noOptionsMessage={() => "không tồn tại"}
                            styles={colourStyles}
                        />
                    )}
                    <button onClick={onSubmit} className="btn btn-primary">Tìm kiếm</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}